import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "TypeScript 프로젝트 참조가 필요하지 않을 수도 있습니다",
  "description": "제가 \"내부 패키지\"라고 부르는 패턴을 사용하면 참조나 중간 TypeScript 빌드 단계조차 필요하지 않을 수 있습니다.",
  "date": "2021/04/23",
  "tag": "web development",
  "ogImage": "/images/blog/you-might-not-need-typescript-project-references/x-card.png"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "대규모 TypeScript 코드베이스나 모노레포에서 작업한 적이 있다면 프로젝트 참조에 익숙할 것입니다. 실제로 매우 강력합니다."
  }, {
    "heading": "",
    "content": "tsconfig.json에서 프로젝트를 참조하면 새로운 일이 발생합니다:"
  }, {
    "heading": "",
    "content": "참조된 프로젝트에서 모듈을 가져오면 대신 출력 선언 파일(.d.ts)이 로드됩니다"
  }, {
    "heading": "",
    "content": "참조된 프로젝트가 outFile을 생성하는 경우 출력 파일 .d.ts 파일의 선언이 이 프로젝트에 표시됩니다"
  }, {
    "heading": "",
    "content": "빌드 모드(tsc -b)를 실행하면 빌드되지 않았지만 필요한 경우 참조된 프로젝트가 자동으로 빌드됩니다"
  }, {
    "heading": "",
    "content": "여러 프로젝트로 분리하면 타입 검사 및 컴파일 속도를 크게 향상시키고, 편집기를 사용할 때 메모리 사용량을 줄이고, 프로그램의 논리적 그룹화 시행을 개선할 수 있습니다."
  }, {
    "heading": "",
    "content": "멋지게 들리죠! 그렇죠?! 음...어쩌면요. 프로젝트에 참조를 추가하면 이제 패키지를 추가하거나 제거할 때마다 계속 업데이트해야 합니다. 좀 귀찮네요."
  }, {
    "heading": "",
    "content": "음...필요하지 않다면 어떨까요?"
  }, {
    "heading": "내부-typescript-패키지",
    "content": "제가 \"내부 패키지\"라고 부르는 패턴을 사용하면 참조나 중간 TypeScript 빌드 단계조차 필요하지 않을 수 있습니다."
  }, {
    "heading": "내부-typescript-패키지",
    "content": "\"내부 패키지\"는 tsconfig.json이 없는 TypeScript 패키지로, package.json의 types 및 main 필드 모두 패키지의 트랜스파일되지 않은 진입점(예: ./src/index.tsx)을 가리킵니다."
  }, {
    "heading": "내부-typescript-패키지",
    "content": "TypeScript 언어 서버(VSCode에서)와 타입 체커는 원시 .ts 또는 .tsx 파일을 자체 유효한 타입 선언으로 처리할 수 있습니다. 이 마지막 문장은 두 번 읽으면 명백합니다. 그러나 명백하지 않은 것은 types 필드를 원시 소스 코드에 직접 가리킬 수 있다는 것입니다."
  }, {
    "heading": "내부-typescript-패키지",
    "content": "이렇게 하면 2가지 규칙을 준수하는 한 이 패키지를 프로젝트 참조나 TypeScript 빌드 단계(tsc 또는 esbuild 등을 통해) 없이 사용할 수 있습니다:"
  }, {
    "heading": "내부-typescript-패키지",
    "content": "내부 패키지를 사용하는 애플리케이션은 이를 트랜스파일하고 타입 체크해야 합니다."
  }, {
    "heading": "내부-typescript-패키지",
    "content": "내부 패키지를 npm에 게시해서는 안 됩니다."
  }, {
    "heading": "내부-typescript-패키지",
    "content": "제가 알기로는 이 내부 패키지 패턴은 Turborepo를 사용하든 다른 도구를 사용하든 관계없이 모든 yarn/npm/pnpm 워크스페이스 구현에서 작동합니다. 여러 다른 메타 프레임워크(아래 참조)로 이 패턴을 개인적으로 테스트했지만 다른 프레임워크에서도 작동할 것으로 확신합니다."
  }, {
    "heading": "nextjs",
    "content": "Next.js 13은 로컬 패키지(모노레포와 같은) 또는 외부 종속성(node_modules)의 종속성을 자동으로 트랜스파일하고 번들링할 수 있습니다."
  }, {
    "heading": "nextjs",
    "content": "Next.js 13.1부터 next-transpile-modules 패키지가 더 이상 필요하지 않습니다.\n자세한 내용은 Next.js 내장 모듈\n트랜스파일레이션\n블로그 게시물을 참조하세요."
  }, {
    "heading": "vite",
    "content": "내부 패키지가 그냥 작동합니다. 추가 구성이 필요하지 않습니다."
  }, {
    "heading": "react-native",
    "content": "Expo를 사용하고 expo-yarn-workspaces 또는 @turborepo/adapter-expo 패키지를 사용하는 경우 iOS 또는 Android를 타겟팅하는 한 내부 패키지를 사용할 수 있습니다. 이러한 플랫폼에서 Expo를 실행하면 모든 node_modules가 Metro로 자동으로 트랜스파일됩니다. 그러나 웹용 Expo를 타겟팅하는 경우 node_modules가 웹용으로 트랜스파일되지 않기 때문에 내부 패키지가 작동하지 않습니다."
  }, {
    "heading": "react-native",
    "content": "Expo 팀에 이 불일치에 대해 연락했습니다. 그들은 이를 인지하고 있습니다. 레거시 문제라고 들었습니다."
  }, {
    "heading": "이-패턴의-아름다움",
    "content": "이 패턴은 불필요하거나 중복된 빌드 단계를 절약하기 때문에 훌륭합니다. 또한 구성 없이 프로젝트 참조의 모든 편집기 이점을 제공합니다."
  }, {
    "heading": "주의사항",
    "content": "내부 패키지를 사용하면 소비 애플리케이션에 또 다른 소스 디렉토리가 있다고 말하는 것과 같습니다. 장단점이 있습니다. 소비 애플리케이션이 커지면 더 많은 내부 패키지를 추가하는 것은 해당 소비 애플리케이션에 더 많은 소스 코드를 추가하는 것과 동일합니다. 따라서 더 많은 소스 코드를 추가하면 트랜스파일/번들/타입 체크할 코드가 더 많아지므로 소비 애플리케이션의 빌드가 느려질 수 있지만(수행할 작업이 더 많기 때문) 전체 빌드 시간은 잠재적으로 더 빠르고 덜 복잡할 수 있습니다. 전체 빌드 시간이 저하되기 시작하면 더 큰 내부 패키지를 .d.ts 파일과 일반 TypeScript 빌드 단계가 있는 \"일반\" 패키지로 다시 변환하기로 결정할 수 있습니다."
  }, {
    "heading": "주의사항",
    "content": "앞서 언급했듯이 이 패턴은 실제로 Turborepo와 거의 관련이 없습니다. 그냥 매우 훌륭하고 여러분이 알고 있어야 한다고 생각합니다. Turborepo용 프리셋 패키지 빌드 규칙(즉, \"빌더\")을 적극적으로 작업하고 있기 때문에 내부 패키지 패턴을 사용하여 빌드 단계를 건너뛸 것입니다."
  }, {
    "heading": "긴-빌드-시간에-대해-말하자면",
    "content": "부끄럽지만 홍보를 하겠습니다. 이 게시물을 읽고 있고 느린 빌드 및 테스트 시간으로 어려움을 겪고 있다면 Turborepo가 어떻게 도움이 될 수 있는지 보여드리고 싶습니다. Turborepo가 모노레포의 빌드 시간을 50% 이상 단축할 것을 보장합니다. 여기에서 라이브 데모를 요청할 수 있습니다."
  }],
  "headings": [{
    "id": "내부-typescript-패키지",
    "content": "\"내부\" TypeScript 패키지"
  }, {
    "id": "nextjs",
    "content": "Next.js"
  }, {
    "id": "vite",
    "content": "Vite"
  }, {
    "id": "react-native",
    "content": "React Native"
  }, {
    "id": "이-패턴의-아름다움",
    "content": "이 패턴의 아름다움"
  }, {
    "id": "주의사항",
    "content": "주의사항"
  }, {
    "id": "긴-빌드-시간에-대해-말하자면",
    "content": "긴 빌드 시간에 대해 말하자면..."
  }]
};
import {Authors} from '#components/authors';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#내부-typescript-패키지",
  title: _jsx(_Fragment, {
    children: "\"내부\" TypeScript 패키지"
  })
}, {
  depth: 3,
  url: "#nextjs",
  title: _jsx(_Fragment, {
    children: "Next.js"
  })
}, {
  depth: 3,
  url: "#vite",
  title: _jsx(_Fragment, {
    children: "Vite"
  })
}, {
  depth: 3,
  url: "#react-native",
  title: _jsx(_Fragment, {
    children: "React Native"
  })
}, {
  depth: 2,
  url: "#이-패턴의-아름다움",
  title: _jsx(_Fragment, {
    children: "이 패턴의 아름다움"
  })
}, {
  depth: 2,
  url: "#주의사항",
  title: _jsx(_Fragment, {
    children: "주의사항"
  })
}, {
  depth: 2,
  url: "#긴-빌드-시간에-대해-말하자면",
  title: _jsx(_Fragment, {
    children: "긴 빌드 시간에 대해 말하자면..."
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      children: "TypeScript 프로젝트 참조가 필요하지 않을 수도 있습니다"
    }), "\n", "\n", _jsx(Authors, {
      authors: ['jaredpalmer']
    }), "\n", _jsxs(_components.p, {
      children: ["대규모 TypeScript 코드베이스나 모노레포에서 작업한 적이 있다면 ", _jsx(_components.a, {
        href: "https://www.typescriptlang.org/docs/handbook/project-references.html",
        children: "프로젝트 참조"
      }), "에 익숙할 것입니다. 실제로 매우 강력합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "tsconfig.json"
      }), "에서 프로젝트를 참조하면 새로운 일이 발생합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["참조된 프로젝트에서 모듈을 가져오면 대신 출력 선언 파일(", _jsx(_components.code, {
          children: ".d.ts"
        }), ")이 로드됩니다"]
      }), "\n", _jsxs(_components.li, {
        children: ["참조된 프로젝트가 ", _jsx(_components.code, {
          children: "outFile"
        }), "을 생성하는 경우 출력 파일 ", _jsx(_components.code, {
          children: ".d.ts"
        }), " 파일의 선언이 이 프로젝트에 표시됩니다"]
      }), "\n", _jsxs(_components.li, {
        children: ["빌드 모드(", _jsx(_components.code, {
          children: "tsc -b"
        }), ")를 실행하면 빌드되지 않았지만 필요한 경우 참조된 프로젝트가 자동으로 빌드됩니다"]
      }), "\n", _jsx(_components.li, {
        children: "여러 프로젝트로 분리하면 타입 검사 및 컴파일 속도를 크게 향상시키고, 편집기를 사용할 때 메모리 사용량을 줄이고, 프로그램의 논리적 그룹화 시행을 개선할 수 있습니다."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "멋지게 들리죠! 그렇죠?! 음...어쩌면요. 프로젝트에 참조를 추가하면 이제 패키지를 추가하거나 제거할 때마다 계속 업데이트해야 합니다. 좀 귀찮네요."
    }), "\n", _jsx(_components.p, {
      children: "음...필요하지 않다면 어떨까요?"
    }), "\n", _jsx(_components.h2, {
      id: "내부-typescript-패키지",
      children: "\"내부\" TypeScript 패키지"
    }), "\n", _jsx(_components.p, {
      children: "제가 \"내부 패키지\"라고 부르는 패턴을 사용하면 참조나 중간 TypeScript 빌드 단계조차 필요하지 않을 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.strong, {
        children: ["\"내부 패키지\"는 ", _jsx(_components.code, {
          children: "tsconfig.json"
        }), "이 없는 TypeScript 패키지로, ", _jsx(_components.code, {
          children: "package.json"
        }), "의 ", _jsx(_components.code, {
          children: "types"
        }), " 및 ", _jsx(_components.code, {
          children: "main"
        }), " 필드 ", _jsx(_components.em, {
          children: "모두"
        }), " 패키지의 트랜스파일되지 않은 진입점(예: ", _jsx(_components.code, {
          children: "./src/index.tsx"
        }), ")을 가리킵니다."]
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@sample/my-internal-package\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "  \"main\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"./src/index.ts\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "  \"types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"./src/index.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // yes, this works!"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"dependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"devDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ..."
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["TypeScript 언어 서버(VSCode에서)와 타입 체커는 원시 ", _jsx(_components.code, {
        children: ".ts"
      }), " 또는 ", _jsx(_components.code, {
        children: ".tsx"
      }), " 파일을 자체 유효한 타입 선언으로 처리할 수 있습니다. 이 마지막 문장은 두 번 읽으면 명백합니다. 그러나 명백하지 않은 것은 ", _jsx(_components.code, {
        children: "types"
      }), " 필드를 원시 소스 코드에 직접 가리킬 수 있다는 것입니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이렇게 하면 2가지 규칙을 준수하는 한 이 패키지를 프로젝트 참조나 TypeScript 빌드 단계(", _jsx(_components.code, {
        children: "tsc"
      }), " 또는 ", _jsx(_components.code, {
        children: "esbuild"
      }), " 등을 통해) ", _jsx(_components.em, {
        children: "없이"
      }), " 사용할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.strong, {
          children: "내부 패키지를 사용하는 애플리케이션은 이를 트랜스파일하고 타입 체크해야 합니다."
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.strong, {
          children: "내부 패키지를 npm에 게시해서는 안 됩니다."
        })
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "제가 알기로는 이 내부 패키지 패턴은 Turborepo를 사용하든 다른 도구를 사용하든 관계없이 모든 yarn/npm/pnpm 워크스페이스 구현에서 작동합니다. 여러 다른 메타 프레임워크(아래 참조)로 이 패턴을 개인적으로 테스트했지만 다른 프레임워크에서도 작동할 것으로 확신합니다."
    }), "\n", _jsx(_components.h3, {
      id: "nextjs",
      children: "Next.js"
    }), "\n", _jsxs(_components.p, {
      children: ["Next.js 13은 로컬 패키지(모노레포와 같은) 또는 외부 종속성(", _jsx(_components.code, {
        children: "node_modules"
      }), ")의 종속성을 자동으로 트랜스파일하고 번들링할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "next.config.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "/** "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "@type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " {import('next').NextConfig}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " */"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " nextConfig"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  transpilePackages"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'@acme/ui'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " 'lodash-es'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "};"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "module"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "exports"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " nextConfig;"
            })]
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["Next.js 13.1부터 ", _jsx(_components.code, {
          children: "next-transpile-modules"
        }), " 패키지가 더 이상 필요하지 않습니다.\n자세한 내용은 Next.js ", _jsx(_components.a, {
          href: "https://nextjs.org/blog/next-13-1#built-in-module-transpilation-stable",
          children: "내장 모듈\n트랜스파일레이션"
        }), "\n블로그 게시물을 참조하세요."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "vite",
      children: "Vite"
    }), "\n", _jsx(_components.p, {
      children: "내부 패키지가 그냥 작동합니다. 추가 구성이 필요하지 않습니다."
    }), "\n", _jsx(_components.h3, {
      id: "react-native",
      children: "React Native"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://expo.dev/",
        children: "Expo"
      }), "를 사용하고 ", _jsx(_components.a, {
        href: "https://github.com/expo/expo/tree/master/packages/expo-yarn-workspaces",
        children: _jsx(_components.code, {
          children: "expo-yarn-workspaces"
        })
      }), " 또는 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@turborepo/adapter-expo",
        children: _jsx(_components.code, {
          children: "@turborepo/adapter-expo"
        })
      }), " 패키지를 사용하는 경우 iOS 또는 Android를 타겟팅하는 한 내부 패키지를 사용할 수 있습니다. 이러한 플랫폼에서 Expo를 실행하면 모든 ", _jsx(_components.code, {
        children: "node_modules"
      }), "가 ", _jsx(_components.a, {
        href: "https://facebook.github.io/metro/",
        children: "Metro"
      }), "로 자동으로 트랜스파일됩니다. 그러나 웹용 Expo를 타겟팅하는 경우 ", _jsx(_components.code, {
        children: "node_modules"
      }), "가 웹용으로 트랜스파일되지 않기 때문에 내부 패키지가 작동하지 않습니다."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Expo 팀에 이 불일치에 대해 연락했습니다. 그들은 이를 인지하고 있습니다. 레거시 문제라고 들었습니다."
      })
    }), "\n", _jsx(_components.h2, {
      id: "이-패턴의-아름다움",
      children: "이 패턴의 아름다움"
    }), "\n", _jsx(_components.p, {
      children: "이 패턴은 불필요하거나 중복된 빌드 단계를 절약하기 때문에 훌륭합니다. 또한 구성 없이 프로젝트 참조의 모든 편집기 이점을 제공합니다."
    }), "\n", _jsx(_components.h2, {
      id: "주의사항",
      children: "주의사항"
    }), "\n", _jsxs(_components.p, {
      children: ["내부 패키지를 사용하면 소비 애플리케이션에 또 다른 소스 디렉토리가 있다고 말하는 것과 같습니다. 장단점이 있습니다. 소비 애플리케이션이 커지면 더 많은 내부 패키지를 추가하는 것은 해당 소비 애플리케이션에 더 많은 소스 코드를 추가하는 것과 동일합니다. 따라서 더 많은 소스 코드를 추가하면 트랜스파일/번들/타입 체크할 코드가 더 많아지므로 소비 애플리케이션의 빌드가 느려질 수 있지만(수행할 작업이 더 많기 때문) 전체 빌드 시간은 잠재적으로 더 빠르고 덜 복잡할 수 있습니다. 전체 빌드 시간이 저하되기 시작하면 더 큰 내부 패키지를 ", _jsx(_components.code, {
        children: ".d.ts"
      }), " 파일과 일반 TypeScript 빌드 단계가 있는 \"일반\" 패키지로 다시 변환하기로 결정할 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "앞서 언급했듯이 이 패턴은 실제로 Turborepo와 거의 관련이 없습니다. 그냥 매우 훌륭하고 여러분이 알고 있어야 한다고 생각합니다. Turborepo용 프리셋 패키지 빌드 규칙(즉, \"빌더\")을 적극적으로 작업하고 있기 때문에 내부 패키지 패턴을 사용하여 빌드 단계를 건너뛸 것입니다."
    }), "\n", _jsx(_components.h2, {
      id: "긴-빌드-시간에-대해-말하자면",
      children: "긴 빌드 시간에 대해 말하자면..."
    }), "\n", _jsxs(_components.p, {
      children: ["부끄럽지만 홍보를 하겠습니다. 이 게시물을 읽고 있고 느린 빌드 및 테스트 시간으로 어려움을 겪고 있다면 Turborepo가 어떻게 도움이 될 수 있는지 보여드리고 싶습니다. Turborepo가 모노레포의 빌드 시간을 50% 이상 단축할 것을 보장합니다. ", _jsx(_components.a, {
        href: "https://vercel.com/contact/sales?utm_source=turborepo.com&utm_medium=referral&utm_campaign=blog-project-references",
        children: "여기에서 라이브 데모를 요청할 수 있습니다."
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
